// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BuYNI","colBig":"styles_colBig__2cwj6","colSmall":"styles_colSmall__2CdxR"};